import Buzz from '@/pages/Buzz'

export default {
    path: '/buzz',
    name: 'Buzz',
    component: Buzz
}


// WEBPACK FOOTER //
// ./src/router/buzz.js